import React, { useState } from 'react'
import { Button, Dropdown } from 'antd'
import getFileIcon from '../../../utils/getFileIcon'
import { removeFileExtension } from '../../../utils/removeFileExtension'
import AiLoadingOverlay from '../AiLoadingOverlay'
import FileActionsMenu from '../FileActionsMenu'
import './FolderCard.scss'

const FolderCard = ({
  item,
  selectedItems,
  onSelectionChange,
  onAction,
  user,
  orgUserList,
  defaultQuery,
  userId,
  isSuperAdmin,
  isAdmin,
  aiProcessingItems,
  setVersionFile,
  setVersionModalVisible,
  setManagePermissionsModalVisible,
  setAuitModal,
  hoveredItemId,
  setHoveredItemId,
  shouldShowCheckbox
}) => {
  const [openDropdownId, setOpenDropdownId] = useState(null)
  return (
    <div
      key={item.id}
      className="file-card grid-file-card simplified-folder-card clickable foldercard-root"
      onClick={() => onAction && onAction('view', item)}
      onMouseEnter={() => setHoveredItemId(item.id)}
      onMouseLeave={() => setHoveredItemId(null)}
    >
      <AiLoadingOverlay isLoading={aiProcessingItems.has(item.id)} />
      {shouldShowCheckbox(item.id) && (
        <input
          type="checkbox"
          checked={selectedItems.includes(item.id)}
          onClick={e => e.stopPropagation()}
          onChange={e => {
            const newSelection = e.target.checked
              ? [...selectedItems, item.id]
              : selectedItems.filter(id => id !== item.id)
            onSelectionChange && onSelectionChange(newSelection)
          }}
        />
      )}
      <div className="foldercard-icon-group">
        <span className="file-type-icon foldercard-type-icon">
          {getFileIcon(item.media_format, item.media_mime_type, 'GRID')}
        </span>
      </div>
      <div className="foldercard-meta-group">
        <span className="file-name foldercard-file-name" title={item.title}>
          {removeFileExtension(item.title || item.filename, item.media_format)}
        </span>
        <span className="folder-subtitle">
          {(() => {
            const fileCount =
              item.counts && typeof item.counts.files === 'number'
                ? item.counts.files
                : 0
            const folderCount =
              item.counts && typeof item.counts.folders === 'number'
                ? item.counts.folders
                : 0
            const fileLabel =
              fileCount > 0
                ? `${fileCount} file${fileCount === 1 ? '' : 's'}`
                : ''
            const folderLabel =
              folderCount > 0
                ? `${folderCount} subfolder${folderCount === 1 ? '' : 's'}`
                : ''
            if (fileLabel && folderLabel) return `${folderLabel} & ${fileLabel}`
            if (fileLabel) return fileLabel
            if (folderLabel) return folderLabel
            return ''
          })()}
        </span>
      </div>
      <div>
        <Dropdown
          overlay={
            <FileActionsMenu
              item={item}
              user={user}
              orgUserList={orgUserList}
              defaultQuery={defaultQuery}
              userId={userId}
              isSuperAdmin={isSuperAdmin}
              isAdmin={isAdmin}
              aiProcessingItems={aiProcessingItems}
              onAction={onAction}
              setVersionFile={setVersionFile}
              setVersionModalVisible={setVersionModalVisible}
              setManagePermissionsModalVisible={
                setManagePermissionsModalVisible
              }
              setAuitModal={setAuitModal}
              closeDropdown={() => setOpenDropdownId(null)}
            />
          }
          visible={openDropdownId === item.id}
          trigger={['click']}
          onVisibleChange={visible => {
            if (visible) {
              setOpenDropdownId(item.id)
            } else {
              setOpenDropdownId(null)
            }
          }}
        >
          <Button
            type="text"
            icon="ellipsis"
            size="small"
            className="foldercard-action-btn"
            onClick={function(e) {
              e.stopPropagation()
            }}
            onMouseDown={function(e) {
              e.stopPropagation()
            }}
          />
        </Dropdown>
      </div>
    </div>
  )
}

export default FolderCard
